import * as React from "react";
import { List, Segment } from "semantic-ui-react";
import changeLogData from "../../change-log";

/*
 * Pure component without any lifecycle methods. Used only to map through data from data/change_log
 * Additional stylings can be added if needed
 */
export default class ChangeLog extends React.PureComponent {
  render(): JSX.Element {
    return (
      <Segment className="container-with-bg" padded>
        <List relaxed={true} divided={true} verticalAlign="middle">
          {changeLogData.map(changeLogItem => (
            <List.Item key={changeLogItem.header.date} className="item">
              <List.Header>
                Sprint: {changeLogItem.header.sprint}, Date: {changeLogItem.header.date}
              </List.Header>
              <List items={changeLogItem.data} />
            </List.Item>
          ))}
        </List>
      </Segment>
    );
  }
}
